import { EditorCursor, selectCursor } from '@/modules/Editor/editorCursor'
import type { Tool, ToolContext } from '@/modules/Editor/managers/toolManager'
import { setupStackScroll } from '@/modules/Editor/plugins/mixins/setupStackScroll'
import { DicomView } from '@/modules/Editor/views/dicomView'
import type { VtkLayer } from '@/modules/Editor/models/layers/vtkLayer'

function getVtkLayersFromContext(context: ToolContext): VtkLayer[] {
  return context.editor.vtkLayers
}

function syncFramesInMultiPlanarViews(context: ToolContext, crosshairsCenter: number[]): void {
  // Reverse the [x, y, z] array to match the order of the views
  crosshairsCenter.reverse()

  context.editor.viewsList.forEach((view, index) => {
    if (view instanceof DicomView) {
      view.jumpToFrameNoLoad(crosshairsCenter[index])
    }
  })
}

/**
 * Crosshairs mouse Tool for left click.
 */
export const crosshairsTool: Tool = {
  activate(context: ToolContext) {
    setupStackScroll.wheel(context)

    const vtkLayers = getVtkLayersFromContext(context)
    if (vtkLayers.length) {
      context.editor.setLayersVisibility(false)

      for (const vtkLayer of vtkLayers) {
        vtkLayer.vtk2DContext?.enablePicking((crosshairsCenter) => {
          syncFramesInMultiPlanarViews(context, crosshairsCenter)
        })
      }

      selectCursor(EditorCursor.BBox)
    }
  },

  deactivate(context: ToolContext): void {
    const vtkLayers = getVtkLayersFromContext(context)
    if (vtkLayers.length) {
      context.editor.setLayersVisibility(true)

      for (const vtkLayer of vtkLayers) {
        vtkLayer.vtk2DContext?.disablePicking()
      }
    }
  },

  reset(): void {},
}
